import { get } from 'lodash'

const getTeams = () => get(window, 'state.teams', [])

export default getTeams
